<template>
  <el-dialog
    :visible="!!editingProject"
    :title="disalbed ? '查看项目' : '编辑项目'"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="币种：" prop="coinType">
        <el-select v-model="detail.coinType" placeholder="请选择">
          <el-option
            v-for="item in coinTypeList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分发币种：" prop="distributionCoinType">
        <el-select
          v-model="detail.distributionCoinType"
          placeholder="请选择"
          disabled
        >
          <el-option
            v-for="item in coinTypeList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="总量：" prop="totalFinancing">
        <el-input-number
          v-model="detail.totalFinancing"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="价格：" prop="price">
        <el-input-number v-model="detail.price" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="抢购设备：" prop="buyLimit">
        <el-select v-model="detail.buyLimit" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="起止时间：" required>
        <el-col :span="7">
          <el-form-item prop="startTime">
            <el-date-picker
              v-model="detail.startTime"
              value-format="timestamp"
              type="datetime"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="endTime">
            <el-date-picker
              v-model="detail.endTime"
              value-format="timestamp"
              type="datetime"
              placeholder="选择截止时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="图片：" prop="imageUrl">
        <upload v-model="detail.imageUrl" :data="{ platform: 1 }"></upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button v-if="!disalbed" type="primary" @click="handleSave()"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'foundationProjectDetail',
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error('请填写'));
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error('请填写'));
      }
      if (this.detail.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'));
      callback();
    };

    return {
      detail: {
        buyLimit: ''
      },
      options: [
        {
          value: '0',
          label: 'PC和APP'
        },
        {
          value: '1',
          label: 'PC'
        },
        {
          value: '2',
          label: 'APP'
        }
      ],
      rules: {
        coinType: {
          required: true,
          message: '请填写'
        },
        price: {
          required: true,
          message: '请填写'
        },
        totalFinancing: {
          required: true,
          message: '请填写'
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change'
          }
        ],
        distributionCoinType: {
          required: true,
          message: '请填写'
        },
        imageUrl: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('foundationProject', [
      'coinTypeList',
      'editingProject',
      'languageList'
    ]),
    disalbed() {
      return this.detail && this.detail.status !== 0;
    }
  },
  watch: {
    editingProject(val) {
      this.detail = val || {};
    }
  },
  components: {
    Editor,
    Upload
  },
  methods: {
    ...mapMutations('foundationProject', ['setEditingProject']),
    ...mapActions('foundationProject', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.update(this.detail).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>
